import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=bf167c68&scoped=true&"
import script from "./Flight.vue?vue&type=script&lang=js&"
export * from "./Flight.vue?vue&type=script&lang=js&"
import style0 from "./Flight.vue?vue&type=style&index=0&id=bf167c68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf167c68",
  null
  
)

export default component.exports